import styled from 'styled-components';

export const ErrorPage = styled.div`
  display: flex;
  padding-top: 0;
  background: ${props => props.theme.colors.gray.extraLight};
`;

export const ErrorPageBody = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-top: 80px;
  padding: 0 10px;
  text-align: center;
  line-height: 26px;

  @media (max-width: ${props => props.theme.sizes.mobile}) {
    margin-top: 40px;
  }
`;

export const ErrorPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const ErrorPageNav = styled.div`
  width: 240px;
  height: 100vh;
  padding-top: 15px;
  text-align: center;
  border-right: 1px dotted #bfbfbf;
`;

export const ErrorPageLogoImage = styled.img`
  width: 160px;
`;

export const ErrorPageImageContainer = styled.div`
  display: inline-block;
  width: 190px;
`;

export const ErrorPageImage = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
`;

export const ErrorPageTitle = styled.h3`
  color: #505050;
  font-size: 34px;
  font-weight: 100;
  line-height: 42px;
`;

export const ErrorPageContent = styled.p`
  color: #505050;
  font-size: 16px;
  font-weight: 300;
`;

export const ErrorPageTextContainer = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
`;
